import Constants from '../constants/Constants';
import {EntitlementType, IUserQuotas} from '../model/userQuotas';
import config from '../service/config';
import userApi from '../service/userApi';
import {create} from 'zustand';

const initialState: IUserQuotas = {
   QuotaEntitlementType: EntitlementType.unknown,
   CurrentBandwidth: 0,
   CurrentStorage: 0,
   CurrentVideoCount: 0,
   VideoCountLimit: 1,
   VideoCountExceeded: false,
   UserHasQuotaInformation: false
};

interface ISet {
   incrementLocalVideoCount: () => void;
   refreshUserQuotasFromApi: () => Promise<void>;
}

const fetchUserQuotasFromApi = async (): Promise<IUserQuotas> => {
   if (!config.featureSwitches.EnableScreencastProEntitlement || !config.user.IsSignedIn) {
      return initialState;
   }
   try {
      const userQuotasResponse = await userApi.getQuotas();
      return {
         QuotaEntitlementType: userQuotasResponse.QuotaEntitlementType,
         CurrentBandwidth: userQuotasResponse.CurrentBandwidth,
         CurrentStorage: userQuotasResponse.CurrentStorage,
         CurrentVideoCount: userQuotasResponse.CurrentVideoCount,
         VideoCountLimit: userQuotasResponse.VideoCountLimit,
         VideoCountExceeded: userQuotasResponse.IsVideoCountAtLimit,
         UserHasQuotaInformation: true
      };
   } catch (e) {
      if (e.status && e.status === Constants.statusCodes.unauthorized) {
         return initialState;
      }
      throw e;
   }
};

const useUserQuotaStore = create<IUserQuotas & ISet>((set, get) => ({
   ...initialState,
   refreshUserQuotasFromApi: async () => {
      const quotas = await fetchUserQuotasFromApi();
      set(quotas);
   },
   incrementLocalVideoCount: () => {
      const updatedVideoCount = get().CurrentVideoCount + 1;
      const newState = {
         CurrentVideoCount: updatedVideoCount,
         VideoCountExceeded: updatedVideoCount === get().VideoCountLimit
      };
      set(newState);
   }
}));

export {
   useUserQuotaStore
};